var render, staticRenderFns
import script from "./TransferPage.vue?vue&type=script&lang=js&"
export * from "./TransferPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/TransferPage.vue"
export default component.exports